import { useRef } from 'react'
import { useScroll } from 'framer-motion'

import { Container } from 'components/container'
import { Layout } from 'components/layout'
import { Share } from 'components/layout/share'
import { ParallaxHeader } from './parallax-header'
import { regions } from './region-list'
import { Article } from './article'
import {
  ArrowDown,
  Articles,
  H1,
  Header,
  HeaderInner,
  Intro,
  ShareContainer,
} from './styled'

export const Home = () => {
  const ref = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'end start'],
  })
  console.log(regions)
  return (
    <Layout>
      <Header ref={ref}>
        <HeaderInner>
          <ParallaxHeader progress={scrollYProgress} />
          <H1>Анализируй Этно</H1>
          <ShareContainer>
            <Share isShare />
          </ShareContainer>
        </HeaderInner>
      </Header>

      <Container>
        <Intro>
          Свыше 190 разных национальностей проживают в современной России. Ее
          география и национальный состав переплетаются с историей завоевания
          земель, на которых жило коренное население. У разных народов – свои
          языки, культура, религия и кухня. Как коренные народы живут в России
          сейчас и как пытаются сохранить собственную национальную идентичность
          – об этом мы рассказываем в специальном проекте Настоящего Времени
          “Анализируй этно”
        </Intro>
      </Container>

      <ArrowDown />

      <Articles>
        <Container>
          {regions.map(props => (
            <Article {...props} key={props.name} />
          ))}
        </Container>
      </Articles>
    </Layout>
  )
}
